define('modules/editor/services/integrations/index',['require','exports','module','common/models/appstate','env'],function (require, exports, module) {
  'use strict';
  var AppState = require('common/models/appstate');
  var Config = require('env');

  var integrations = {
    MDirector: {},
    Email: {},
    Webservice: {},
    CorreoDirect: {},
  };

  function integrationUrl(id, name) {
    console.log('integrationUrl(', id, name);
    return [Config.apiHost, 'pages', id, 'integration', name.toLowerCase()].join('/');
  }

  function addIntegration(name, data) {
    if (data.active) {
      integrations[name] = data.fields;
    }
  }

  module.exports = {
    checkVariable: function (variable) {
      return _.reduce(
        integrations,
        function (found, integration, name) {
          if (_.has(integration, variable)) found.push(name);
          return found;
        },
        []
      );
    },
    fetchStatus: function (model) {
      _.map(_.keys(integrations), function (name) {
        $.get(integrationUrl(model.get('pages_id'), name)).then(_.partial(addIntegration, name));
      });
    },
  };
});

